module.exports = __webpack_public_path__ + "img/Butterfly_00338.c55b1ec8.png";